export enum PaymentsStatusFilter {
  All = "All",
  Succeeded = "Succeeded",
  Failed = "Failed",
}
